<template>
  <div>
    <div id="videoPlayer" style="width: 100%; height: 400px" class="video-js videoBox" muted @contextmenu.prevent="handleContextMenu"></div>

    <div class="videoNme">
      <div class="name">{{ videoInfo.cwName }}</div>
      <!-- <div class="hangye">所属课程：{{ courseName }}</div> -->
    </div>

    <div class="tab">
      <div :class="tabIndex == '1' ? 'tablan active' : 'tablan'" @click="tabIndex = 1">课程章节  <div class="bor"
             v-if="tabIndex == '1'">

        </div></div>
      <div :class="tabIndex == '2' ? 'tablan active' : 'tablan'" @click="tabIndex = 2">温馨提示 <div class="bor"
             v-if="tabIndex == '2'">

        </div></div>
     
    </div>

    <div v-if="tabIndex == '1'" class="chaper">
      <div class="zjBox" v-for="(item) in chapterList" :key="item.chapterId" >
        <div :class="videoInfo.chapterId == item.chapterId ? 'chName activeColor' : 'chName'">
          {{ item.cwName }}
        </div>

        <div class="xsOrBtn">
          <div class="xs"></div>
          <div class="btn activeBtn" v-if="videoInfo.chapterId == item.chapterId">正在试看</div>
          <!-- <div class="btn" v-else>试看</div> -->
        </div>
      </div>
    </div>

    <div v-if="tabIndex == '2'" class="wxts">
      <!-- <div>1.学习前务必填写完整的个人信息，否则无法登记学时证明；</div> -->
      <div>1.如果视频无法播放，推荐使用QQ浏览器；</div>
      <!-- <div>3.课程通过后可自主打印学时证明；</div> -->
      <div>2.如您需要发票请到缴费订单管理界面申领电子发票。</div>
    </div>
  </div>
</template>

<script>
import HlsPlugin from 'xgplayer-hls';
import Player from 'xgplayer';
import { findCourseChapterList } from '../../api/vip';
import { Dialog } from 'vant';

export default {
  data() {
    return {
      tabIndex: 1,
      player: null,
      chapterList: [],
      videoInfo: {},
      courseName: '',
      queryPams: {}
    };
  },
  created() {
    // this.courseName = this.$route.query.courseName;
    this.queryPams.courseId = this.$route.query.id;
    // this.queryPams.coursewareId = this.$route.query.courseWareId;

    this.getData();
  },
  methods: {
    handleContextMenu() {
      this.$utils.showToast('右击被禁用！');
    },
    getData() {
      const data = {
        courseId: this.$route.query.id
      };
      findCourseChapterList(data).then(res => {
        console.log(res.data.data.courseChapterList.rows);
        this.chapterList = res.data.data.courseChapterList.rows;
        this.videoInfo = this.chapterList[0];
        this.getVideo(this.videoInfo);
      });
    },

    playChapter(chapter) {
      this.videoInfo = chapter;
      this.getVideo(chapter);
    },

    getVideo(videoUrl) {
      if (this.player !== null) {
        this.player.destroy('videoPlayer');
      }
      if (videoUrl.isZjw == '1' || videoUrl.isYlx == '1') {
        this.player = new Player({
          id: 'videoPlayer',
          autoplay: true,
          playsinline: true,
          fullscreen: false,
          url: videoUrl.launch,
          progressDisabled: true
        });
      } else {
        // 判断视频源是否是 m3u8 格式
        if (/\.m3u8$/.test(videoUrl.launch)) {
          this.player = new Player({
            id: 'videoPlayer',
            autoplay: true,
            playsinline: true,
            url: videoUrl.launch,
            fullscreen: false,
            progressDisabled: true,
            plugins: [HlsPlugin] // 第二步
          });
        } else {
          let url = videoUrl.launch + '.mp4';
          this.player = new Player({
            id: 'videoPlayer',
            autoplay: true,
            playsinline: true,
            fullscreen: false,
            url: url,
            progressDisabled: true
          });
        }
      }
      let _this = this;
      _this.player.on('loadstart', function () {});
      _this.player.on('progress', function () {});
      _this.player.on('loadedmetadata', function () {});
      _this.player.on('canplaythrough', function () {});
      _this.player.on('waiting', function () {});
      _this.player.on('play', function () {});
      _this.player.on('playing', function () {});
      _this.player.on('pause', function () {});
      _this.player.on('ended', function () {});
      _this.player.on('error', function () {
        console.log('加载错误');
      });
      _this.player.on('seeking', function () {});
      _this.player.on('seeked', function () {});
      _this.player.on('ratechange', function () {});
      _this.player.on('timeupdate', function (e) {
        _this.timeupdate();
      });
      _this.player.on('volumechange', function () {
        console.log('音量改变');
      });
      _this.player.on('stalled', function () {
        console.log('网速异常');
      });
    },
    timeupdate() {
      if (this.player.currentTime > 300) {
        this.player.currentTime = 0;
        Dialog.confirm({
          title: '温馨提示',
          message: '试看五分钟已结束，请点击确定按钮返回购买完整课程后继续观看！'
        })
          .then(() => {
            this.$router.back();
          })
          .catch(() => {
            // on cancel
          });
        return false;
      }
    },
    playNextVideo() {
      const currentIndex = this.chapterList.findIndex(chap => chap.chapterId === this.videoInfo.chapterId);
      if (currentIndex >= 0 && currentIndex < this.chapterList.length - 1) {
        const nextChapter = this.chapterList[currentIndex + 1];
        this.playChapter(nextChapter);
      }
    }
  },
  destroyed() {
    if (this.player) {
      this.player.destroy();
    }
  }
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
#videoPlayer {
  margin-top: 50px;
  width: 100% !important;
  height: 211px !important;
}
.videoNme {
  width: 100%;
  height: auto;
  background: #ffffff;
  border-radius: 0px 0px 8px 8px;
  padding: 20px 15px;
  .name {
    width: 100%;
    //overflow: hidden;
    //white-space: nowrap;
    //text-overflow: ellipsis;
    color: #333333;
    font-size: 16px;
  }
  .hangye {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #999999;
    margin-top: 7px;
    font-size: 13px;
  }
}

.tab {
  display: flex;
  margin-top: 28px;
  padding: 0 15px;
  .tablan {
    position: relative;
    margin-right: 26px;
    font-size: 15px;
    color: #333;
   
  }
   .bor {
      position: absolute;
      bottom: 2px;
      left: 0;
      width: 64px;
      height: 5px;
      background: linear-gradient(90deg, #2a70f2 0%, rgba(42, 112, 242, 0) 100%);
      border-radius: 0px 0px 0px 0px;
    }
  .active {
    font-size: 16px;
    font-weight: 600;
  }
}

.chaper {
  margin-top: 12px;
  background: #fff;
  width: 100%;
  // min-height: 498px;
  padding: 15px;
  .zjBox {
    display: flex;
    margin-bottom: 35px;
    .activeTitle {
      background: #2a70f2 !important;
      color: #fff !important;
    }
    .activeColor {
      color: #2a70f2 !important;
    }
    .activeBtn {
      background: #2a70f2 !important;
      color: #fff !important;
    }
    .zjIndex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bq {
        width: 48px;
        height: 24px;
        background: #f6f8fa;
        border-radius: 4px 4px 4px 4px;
        color: #666666;
        font-size: 13px;
        text-align: center;
        line-height: 24px;
      }
      .wcd {
        color: #9d9d9d;
        font-size: 12px;
      }
    }
    .chName {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #333333;
      margin: 10px 0 1px 0;
      font-weight: 500;
    }
    .xsOrBtn {
      display: flex;
      justify-content: space-between;
      .xs {
        margin-top: 8px;
        color: #999999;
        font-size: 13px;
      }
      .btn {
        margin-top: 4px;
        width: 74px;
        height: 32px;
        background: #f3f3f5;
        border-radius: 27px 27px 27px 27px;
        text-align: center;
        line-height: 32px;
        font-size: 13px;
        color: #2a70f2;
      }
    }
  }
}

.wxts {
  margin-top: 12px;
  background: #fff;
  width: 100%;
  padding: 20px 15px;
  color: #666666;
  font-size: 13px;
  line-height: 25px;
}
</style>
